import { useQuery } from '@tanstack/react-query';
import { patientsApi } from '../api/patients.api';

export const patientsQueryKey = ['patients'] as const;

/** Fetches the account holder + attached dependents. Cached for the session. */
export function usePatients() {
  return useQuery({
    queryKey: patientsQueryKey,
    queryFn: patientsApi.getPatients,
    staleTime: 5 * 60_000,
  });
}
